import { useMemo } from 'react';
import { useAtomValue } from 'jotai';

import { useIsWorkerPersonalInfoMissing } from '../my-profile-section';
import { useIsWorkerMovementInfoMissing } from '../movements-section';
import { useIsWorkerMediaInfoMissing } from '../media-section';
import { useIsWorkerPresentationInfoMissing } from '../presentation-section';
import { newToSectorHavingNoExperienceAtom } from '../../global-state.worker-data';
import { workerPastExperiencesAtom } from '../../global-state.worker-data';
import { useIsWorkerLanguageInfoMissing } from '../language-section';
import { useIsWorkerTrainingInfoMissing } from '../training-section';
import { useIsWorkerCertificationInfoMissing } from '../certification-section';

function useIsWorkerProfileComplete() {
  const newToSectorHavingNoExperience = useAtomValue(newToSectorHavingNoExperienceAtom);
  const workerPastExperiences = useAtomValue(workerPastExperiencesAtom);

  const { isPersonalInfoMissing } = useIsWorkerPersonalInfoMissing();
  const { isWorkerMovementInfoMissing } = useIsWorkerMovementInfoMissing();
  const { isWorkerMediaInfoMissing } = useIsWorkerMediaInfoMissing();
  const { isWorkerPresentationInfoMissing } = useIsWorkerPresentationInfoMissing();
  const { isWorkerLanguageInfoMissing } = useIsWorkerLanguageInfoMissing();
  const { isWorkerTrainingInfoMissing } = useIsWorkerTrainingInfoMissing();
  const { isWorkerCertificationInfoMissing } = useIsWorkerCertificationInfoMissing();

  const isWorkExperienceMissing = useMemo(
    () => !newToSectorHavingNoExperience && workerPastExperiences?.length === 0,
    [newToSectorHavingNoExperience, workerPastExperiences?.length]
  );

  return {
    isWorkerProfileComplete:
      !isPersonalInfoMissing &&
      !isWorkerMovementInfoMissing &&
      !isWorkerMediaInfoMissing &&
      !isWorkerPresentationInfoMissing &&
      !isWorkExperienceMissing &&
      !isWorkerLanguageInfoMissing &&
      !isWorkerTrainingInfoMissing &&
      !isWorkerCertificationInfoMissing,
  };
}

export default useIsWorkerProfileComplete;
